// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mB4Z5","name":"styles_name__3cdmG","phone":"styles_phone__2nfct"};